import React from 'react'
import { Divider } from 'react-native-paper'
import { Text, View, StyleSheet, StyleProp, ViewStyle } from 'react-native'
import capitalize from 'lodash/capitalize'
import { dateMask } from '../../../../utils/helpers/masking'

interface OtherInvoiceInfoProps {
  type: string
  invoice_number: string
  invoice_due_date: string
  style?: StyleProp<ViewStyle>
  dividerStyle?: StyleProp<ViewStyle>
}

export const OtherInvoiceInfo_v2: React.FC<OtherInvoiceInfoProps> = ({
  type,
  invoice_number,
  invoice_due_date,
  style,
}) => {
  return (
    <View style={[styles.container, style]}>
      {/* Invoice Type and Number */}
      <View style={styles.infoRow} testID="invoice-info">
        <Text style={styles.typeText} testID="invoice-type-and_number">
          {`${capitalize(type).replace('_', ' ')} #${invoice_number}`}
        </Text>
        <Text style={styles.dueDateText} testID="invoice-due-date">
          {`Due on ${dateMask(invoice_due_date)}`}
        </Text>
      </View>

      {/* Divider */}
      <Divider style={styles.divider} testID="divider" />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    marginTop: 14,
  },
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center', // Ensures vertical alignment
  },
  typeText: {
    fontSize: 14,
    fontFamily: 'Inter',
    fontWeight: '500',
    lineHeight: 21,
    color: '#394D5A',
    maxWidth: '50%',
  },
  dueDateText: {
    fontSize: 14,
    fontFamily: 'Inter',
    fontWeight: '500',
    lineHeight: 21,
    color: '#001929',
    textAlign: 'right',
  },
  divider: {
    marginTop: 14,
    marginBottom: 14,
  },
})
